module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Code/Control-4e5318e6e77dbc0fc3535dabd0d8a677485872a1c8c4748bf13f1955b4265144.svg";